import React from 'react';
import { Box, Grid, Card, CardContent, Typography, CardActionArea } from '@mui/material';
import { Link } from 'react-router-dom';

const PlayerStatsPage = () => {
    const statCategories = [
        {
            title: "Career Stats",
            description: "Lifetime performance statistics for all players",
            stats: [
                { name: "General Career Stats", path: "/stats/players/career/general", description: "Overall career performance including WAR, games played, and key metrics" },
                { name: "Batting Career Stats", path: "/stats/players/career/batting", description: "Lifetime batting statistics including hits, home runs, batting average" },
                { name: "Pitching Career Stats", path: "/stats/players/career/pitching", description: "Career pitching stats including wins, ERA, strikeouts, and saves" },
                { name: "Fielding Career Stats", path: "/stats/players/career/fielding", description: "Lifetime fielding performance including fielding percentage and defensive metrics" }
            ]
        },
        {
            title: "Season Stats",
            description: "Year-by-year performance statistics",
            stats: [
                { name: "General Season Stats", path: "/stats/players/season/general", description: "Season-by-season overview with WAR, games, and key performance indicators" },
                { name: "Batting Season Stats", path: "/stats/players/season/batting", description: "Yearly batting statistics with detailed offensive metrics" },
                { name: "Pitching Season Stats", path: "/stats/players/season/pitching", description: "Seasonal pitching performance including ERA, wins, and advanced metrics" },
                { name: "Fielding Season Stats", path: "/stats/players/season/fielding", description: "Yearly fielding statistics and defensive performance data" }
            ]
        }
    ];

    return (
        <Box sx={{ p: 3 }}>
            <Typography variant="h3" component="h1" gutterBottom sx={{ mb: 4 }}>
                Player Statistics
            </Typography>
            
            <Typography variant="h6" color="text.secondary" sx={{ mb: 4 }}>
                Explore comprehensive player statistics across different categories and time periods
            </Typography>

            {statCategories.map((category, categoryIndex) => (
                <Box key={categoryIndex} sx={{ mb: 6 }}>
                    <Typography variant="h4" component="h2" gutterBottom sx={{ mb: 2 }}>
                        {category.title}
                    </Typography>
                    <Typography variant="body1" color="text.secondary" sx={{ mb: 3 }}>
                        {category.description}
                    </Typography>
                    
                    <Grid container spacing={3}>
                        {category.stats.map((stat, statIndex) => (
                            <Grid item xs={12} sm={6} md={6} lg={3} key={statIndex}>
                                <Card 
                                    sx={{ 
                                        height: '100%',
                                        transition: 'transform 0.2s ease-in-out, box-shadow 0.2s ease-in-out',
                                        '&:hover': {
                                            transform: 'translateY(-4px)',
                                            boxShadow: 4
                                        }
                                    }}
                                >
                                    <CardActionArea 
                                        component={Link} 
                                        to={stat.path}
                                        sx={{ height: '100%', display: 'flex', flexDirection: 'column', alignItems: 'stretch' }}
                                    >
                                        <CardContent sx={{ flexGrow: 1, display: 'flex', flexDirection: 'column' }}>
                                            <Typography variant="h6" component="h3" gutterBottom sx={{ fontWeight: 600 }}>
                                                {stat.name}
                                            </Typography>
                                            <Typography variant="body2" color="text.secondary" sx={{ flexGrow: 1 }}>
                                                {stat.description}
                                            </Typography>
                                        </CardContent>
                                    </CardActionArea>
                                </Card>
                            </Grid>
                        ))}
                    </Grid>
                </Box>
            ))}
        </Box>
    );
};

export default PlayerStatsPage; 